import React, { useEffect, useRef, useState } from 'react';
import { LayoutPropType } from 'src/modules/parkplusStoreV2/types/layout';
import s from './PotdListing.module.scss';
import useStoreItemClick from 'src/modules/parkplusStoreV2/hooks/useStoreItemClick';
import useParkplusStoreV2 from 'src/modules/parkplusStoreV2/hooks/useParkplusStoreV2';
import classNames from 'classnames';
import AnimatedImage from 'core-lib/components/AnimatedImage';

let timeout;

enum SessionStorage {
    potdAnimation = "potdAnimation",
}

const PotdListing = ({ data }: LayoutPropType) => {
    const rootRef = useRef();
    const { handleItemClickWithDelegation } = useStoreItemClick();
    const { cartData } = useParkplusStoreV2();
    const CARDID = data.layoutType;
    const [activeIndex, setActiveIndex] = useState(null);
    const [showOverlay, setShowOverlay] = useState(false);
    const isFirstVisit = sessionStorage.getItem(SessionStorage.potdAnimation) === null;

    useEffect(() => {
        if (isFirstVisit) {
            setShowOverlay(true);
            sessionStorage.setItem(SessionStorage.potdAnimation, 'true');

            timeout = setTimeout(() => {
                setShowOverlay(false);
            }, 2000);
        }

        return () => {
            if (timeout) {
                clearTimeout(timeout);
            }
        };
    }, [isFirstVisit]);

    const handleClick = (e, id) => {
        setActiveIndex(id); // Set active index to apply animation
        setTimeout(() => {
            handleItemClickWithDelegation(
                e,
                CARDID,
                data?.entityType,
                data?.data,
                data?.title
            );
            setActiveIndex(null); // Reset animation
        }, 1000);
    };

    return (
        <>
            {showOverlay && (
                <div className={s.overlay}>
                </div>
            )}
            <div
                className={classNames(s.root, {
                    [s.active]: cartData?.data?.length > 0,
                    [s.stripData]: cartData?.stripData,
                })}
                ref={rootRef}
            >
                {data?.data?.map((item, id) => (
                    <div
                        className={`${s.image} ${id === activeIndex ? s.imageEnlarged : ''}`}
                        key={item?.productId}
                        id={CARDID}
                        data-index={id}
                        onClick={(e) => handleClick(e, id)}
                    >
                        <AnimatedImage src={item?.coverImage} alt="img" />
                    </div>
                ))}
            </div>
        </>
    );
};

export default PotdListing;
